import {
  DEFAULT_PER_PAGE,
  DEFAULT_PAGE,
} from '@/finsight/application/actions/bonds/constants';

export const initialInventoriesData = {
  inventories: {
    collection: [],
    totalCount: 0,
  },
  lastImportAt: null,
  subscriptionStatus: {
    subscriptionId: null,
    isSubscribed: null,
    subscriptionName: '',
    subscriptionSubgroupName: '',
  },
};

export const initialBwicData = {
  bwics: {
    collection: [],
    totalCount: 0,
  },
  lastImportAt: null,
  subscriptionStatus: {
    subscriptionId: null,
    isSubscribed: null,
    subscriptionName: '',
    subscriptionSubgroupName: '',
  },
};

export const initialFiltersState = {
  sortBy: '',
  sortOrder: '',
  page: 1,
  perPage: 25,
  search: '',
};

export const defaultFiltersPayload = {
  dateFrom: null,
  dateTo: null,
  includedStatus: 'all',
  includedSubsectorIds: [],
  includedIssuerIds: [],
  includedDealerIds: [],
  includedBenchmarkGroupIds: [],
  includedSpeedTypeIds: [],
  includedRatingGroupIds: [],
  includedRatingAgencyIds: [],
  currentFaceRangeIds: [],
  includedSectorIds: [],
  includedDealIds: [],
  includedParentIds: [],
  excludedSectorIds: [],
  includedIndustryIds: [],
  includedSubindustryIds: [],
  includedCurrentFaces: [
    {
      includedCurrentFaceFrom: null,
      includedCurrentFaceTo: null,
    },
  ],
  includedWalFrom: null,
  includedWalTo: null,
  includedSpreadFrom: null,
  includedSpreadTo: null,
  includedSpeedFrom: null,
  includedSpeedTo: null,
};

export const defaultTileFilterPayload = {
  perPage: DEFAULT_PER_PAGE,
  page: DEFAULT_PAGE,
  search: '',
};
